@if (avoinna()) {
  <div class="search-overlay" (mousedown)="taustaaKlikattu($event)">
    <div class="search-panel" role="dialog" aria-modal="true" cdkTrapFocus [attr.aria-label]="'asiakkaat.haku.modal-otsikko' | translate | async">
      <button class="search-close" type="button" (click)="sulje()" [attr.aria-label]="'asiakkaat.haku.sulje' | translate | async">
        <mat-icon>close</mat-icon>
      </button>

      <div class="search-content">
        <div class="hakupalkki">
          <mat-icon>search</mat-icon>
          <input type="text" #hakukentta [formField]="hakuteksti" [placeholder]="'asiakkaat.haku.hakukentan-placeholder' | translate | async" [attr.aria-label]="'asiakkaat.haku.hakukentan-placeholder' | translate | async" autocomplete="off" />
          @if (hakusana()) {
            <button type="button" class="hakupalkki-tyhjenna" (click)="tyhjennaHakuteksti()" [attr.aria-label]="'asiakkaat.haku.tyhjenna' | translate | async">
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>

        <div class="filters">
          <div class="dropdown-wrap">
            <button type="button" class="filter-btn" [class.filter-btn-active]="valitutTyypit.size > 0" (click)="vaihdaPaneeli('tyyppi')">
              @if (valitutTyypit.size > 0) {
                <span>{{ 'asiakkaat.haku.suodatin-tyyppi' | translate | async }} · {{ valitutTyypit.size }}</span>
              } @else {
                <span>{{ 'asiakkaat.haku.suodatin-tyyppi' | translate | async }}</span>
              }
              <mat-icon class="filter-caret">expand_more</mat-icon>
            </button>

            @if (avoinPaneeli === 'tyyppi') {
              <div class="dropdown">
                @for (vaihtoehto of kaikkiTyypit; track vaihtoehto.tyyppi) {
                  <label class="dropdown-item">
                    <input type="checkbox" [checked]="valitutTyypit.has(vaihtoehto.tyyppi)" (change)="vaihdaTyyppi(vaihtoehto.tyyppi)" />
                    <span>{{ vaihtoehto.nimiAvain | translate | async }}</span>
                  </label>
                }
                @if (valitutTyypit.size > 0) {
                  <button type="button" class="dropdown-clear" (click)="tyhjennaTyypit()">
                    {{ 'asiakkaat.haku.tyhjenna-valinnat' | translate | async }}
                  </button>
                }
              </div>
            }
          </div>

          <div class="dropdown-wrap">
            <button type="button" class="filter-btn" [class.filter-btn-active]="valitutMyynninLajit.size > 0" (click)="vaihdaPaneeli('myynninLaji')">
              @if (valitutMyynninLajit.size > 0) {
                <span>{{ 'asiakkaat.haku.suodatin-myynnin-laji' | translate | async }} · {{ valitutMyynninLajit.size }}</span>
              } @else {
                <span>{{ 'asiakkaat.haku.suodatin-myynnin-laji' | translate | async }}</span>
              }
              <mat-icon class="filter-caret">expand_more</mat-icon>
            </button>

            @if (avoinPaneeli === 'myynninLaji') {
              <div class="dropdown">
                @for (myynninLaji of kaikkiMyynninLajit(); track myynninLaji) {
                  <label class="dropdown-item">
                    <input type="checkbox" [checked]="valitutMyynninLajit.has(myynninLaji)" (change)="vaihdaMyynninLaji(myynninLaji)" />
                    <span>{{ 'myynnin-laji.' + myynninLaji | translate | async }}</span>
                  </label>
                }
                @if (valitutMyynninLajit.size > 0) {
                  <button type="button" class="dropdown-clear" (click)="tyhjennaMyynninLajit()">
                    {{ 'asiakkaat.haku.tyhjenna-valinnat' | translate | async }}
                  </button>
                }
              </div>
            }
          </div>

          <div class="dropdown-wrap">
            <button type="button" class="filter-btn" [class.filter-btn-active]="valitutToimitustavat.size > 0" (click)="vaihdaPaneeli('toimitustapa')">
              @if (valitutToimitustavat.size > 0) {
                <span>{{ 'asiakkaat.haku.suodatin-toimitustapa' | translate | async }} · {{ valitutToimitustavat.size }}</span>
              } @else {
                <span>{{ 'asiakkaat.haku.suodatin-toimitustapa' | translate | async }}</span>
              }
              <mat-icon class="filter-caret">expand_more</mat-icon>
            </button>

            @if (avoinPaneeli === 'toimitustapa') {
              <div class="dropdown">
                @for (vaihtoehto of kaikkiToimitustavat; track vaihtoehto.lahetystapa) {
                  <label class="dropdown-item">
                    <input type="checkbox" [checked]="valitutToimitustavat.has(vaihtoehto.lahetystapa)" (change)="vaihdaToimitustapa(vaihtoehto.lahetystapa)" />
                    <span>{{ vaihtoehto.nimiAvain | translate | async }}</span>
                  </label>
                }
                @if (valitutToimitustavat.size > 0) {
                  <button type="button" class="dropdown-clear" (click)="tyhjennaToimitustavat()">
                    {{ 'asiakkaat.haku.tyhjenna-valinnat' | translate | async }}
                  </button>
                }
              </div>
            }
          </div>

          <div class="dropdown-wrap">
            <button type="button" class="filter-btn" [class.filter-btn-active]="valitutPaikkakunnat.size > 0" (click)="vaihdaPaneeli('paikkakunta')">
              @if (valitutPaikkakunnat.size > 0) {
                <span>{{ 'asiakkaat.haku.suodatin-paikkakunta' | translate | async }} · {{ valitutPaikkakunnat.size }}</span>
              } @else {
                <span>{{ 'asiakkaat.haku.suodatin-paikkakunta' | translate | async }}</span>
              }
              <mat-icon class="filter-caret">expand_more</mat-icon>
            </button>

            @if (avoinPaneeli === 'paikkakunta') {
              <div class="dropdown">
                <input type="text" class="dropdown-rajaus" [formField]="paikkakuntaRajaus" [placeholder]="'asiakkaat.haku.rajaa-listaa' | translate | async" />
                @if (rajatutPaikkakunnat.length === 0) {
                  <div class="dropdown-empty">{{ 'asiakkaat.haku.ei-valintoja' | translate | async }}</div>
                }
                @for (paikkakunta of rajatutPaikkakunnat; track paikkakunta) {
                  <label class="dropdown-item">
                    <input type="checkbox" [checked]="valitutPaikkakunnat.has(paikkakunta)" (change)="vaihdaPaikkakunta(paikkakunta)" />
                    <span>{{ paikkakunta }}</span>
                  </label>
                }
                @if (valitutPaikkakunnat.size > 0) {
                  <button type="button" class="dropdown-clear" (click)="tyhjennaPaikkakunnat()">
                    {{ 'asiakkaat.haku.tyhjenna-valinnat' | translate | async }}
                  </button>
                }
              </div>
            }
          </div>
        </div>

        <div class="results">
          @if (haetaan()) {
            <div class="hint">{{ 'asiakkaat.haku.haetaan' | translate | async }}</div>
          } @else if (!onkoHakuehtoja) {
            <div class="hint">{{ 'asiakkaat.haku.hakuohje' | translate | async }}</div>
          } @else if (tulokset().length === 0) {
            <div class="hint">
              {{ hakusana() ? ('asiakkaat.haku.ei-osumia-haulla' | translate: { hakusana: hakusana() } | async) : ('asiakkaat.haku.ei-tuloksia' | translate | async) }}
              <div>{{ 'asiakkaat.haku.ei-tuloksia-vihje' | translate | async }}</div>
              @if (onkoHakuehtoja) {
                <div>
                  <button type="button" class="tyhjenna-kaikki" (click)="tyhjennaKaikki()">{{ 'asiakkaat.haku.tyhjenna-kaikki' | translate | async }}</button>
                </div>
              }
            </div>
          } @else {
            <table class="tulokset-taulukko">
              <thead>
                <tr>
                  <th>{{ 'asiakkaat.nimi' | translate | async }}</th>
                  <th>{{ 'asiakkaat.ytunnus' | translate | async }}</th>
                  <th>{{ 'asiakkaat.paikkakunta' | translate | async }}</th>
                  <th>{{ 'asiakkaat.myynnin-laji' | translate | async }}</th>
                  <th>{{ 'asiakkaat.toimitus' | translate | async }}</th>
                  <th class="r">{{ 'asiakkaat.maksuehto' | translate | async }}</th>
                </tr>
              </thead>
              <tbody>
                @for (asiakas of tulokset(); track asiakas.avain) {
                  <tr class="tulos-rivi" tabindex="0" (click)="avaaAsiakas(asiakas)" (keydown.enter)="avaaAsiakas(asiakas)" (keydown.space)="$event.preventDefault(); avaaAsiakas(asiakas)">
                    <td>
                      <div class="tulos-otsikko">
                        <mat-icon class="tyyppi-ikoni">{{ asiakas.asiakastyyppi === 'h' ? 'person' : 'business' }}</mat-icon>
                        {{ asiakas.nimi }}
                      </div>
                    </td>
                    <td>{{ asiakas.ytunnus || '–' }}</td>
                    <td>
                      <span>{{ asiakas.postitmp }}</span>
                      @if (asiakas.maa && asiakas.maa !== 'FIN') {
                        <span>{{ asiakas.postitmp ? ', ' : '' }}{{ asiakas.maa | lmaa | async }}</span>
                      }
                    </td>
                    <td>{{ asiakas.laskunTyyppi ? ('myynnin-laji.' + asiakas.laskunTyyppi | translate | async) : '–' }}</td>
                    <td class="toimitus">{{ asiakas.toimitusteksti }}</td>
                    <td class="r">
                      @if (asiakas.maksuaikaa) {
                        {{ asiakas.maksuaikaa }} {{ 'lasku.pv-netto' | translate | async }}
                      } @else {
                        –
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>

            <div class="tulokset-alareuna">
              @if (onkoHakuehtoja) {
                <button type="button" class="tyhjenna-kaikki" (click)="tyhjennaKaikki()">{{ 'asiakkaat.haku.tyhjenna-kaikki' | translate | async }}</button>
              }
              <span class="osumia">{{ 'asiakkaat.haku.osumia' | translate: { maara: kokonaismaara() } | async }}</span>
            </div>
            <mat-paginator class="haku-paginator" [length]="kokonaismaara()" [pageIndex]="sivu" [pageSize]="sivunKoko" [pageSizeOptions]="sivukoot" showFirstLastButtons (page)="sivuMuuttui($event)"></mat-paginator>
          }
        </div>
      </div>
    </div>
  </div>
}
